<template>

    <div class="book-detail-container" v-wechat-title="bookDetail.title">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container" style="position: fixed;top: 0">
            <span class="title-style">{{bookDetail.title}}</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <!--書籍介紹-->
        <div class="book-intro-container">
            <img :src="bookDetail.pic1" alt="">
            <ul>
                <li>
                    <span style="top: 10%;font-weight: bold">{{bookDetail.title}}</span>
                </li>
                <li>
                    <span style="top: 25%;">作者：{{bookDetail.author}}</span>
                </li>
                <li>
                    <span style="top: 25%;">狀態：{{bookDetail.zt}}</span>
                </li>
                <li>
                    <span style="top: 25%;">類型：{{bookDetail.type}}</span>
                </li>
                <li>
                    <span style="top: 25%;">閱讀：{{bookDetail.rd}}</span>
                </li>
            </ul>
        </div>

        <!--簡介-->
        <div style="text-align: left;padding: 10px">
            <p style="color: #666666;line-height: 25px;font-size: 14px">{{bookDetail.content}}</p>
        </div>

        <!--分割線-->
        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

        <!--目錄-->
        <div @click="categoryClick" style="text-align: left;margin-top: 5px;margin-bottom: 5px;cursor: pointer">
            <span style="margin-left: 2%;font-size: 16px;font-weight: bold">目錄</span>
            <div style="margin-left: 2%;margin-right: 2%;margin-top: 10px;">
                <span style="float: left">{{bookDetail.last_title}}</span>
                <span style="margin-left: 20px">{{bookDetail.update_rq}}</span>
            </div>
        </div>

        <!--分割線-->
        <div style="width: 100%;height: 10px;background-color: lightgray"></div>

        <!--評論-->
        <div class="comment-container">
            <div style="padding: 10px 10px 0;">
                <span style="float: left;font-weight: bold">評論</span>
            </div>
            <ul>
                <li v-for="comment in comments">
                    <span style="color: #ea477b">{{comment.nicheng}}</span>
                    <span style="float: right">{{comment.insert_time}}</span>
                    <p style="color: #333333;line-height: 20px">{{comment.content}}</p>
                </li>
            </ul>
        </div>

        <!--分割線-->
        <div style="width: 100%;height: 10px;background-color: lightgray"></div>

        <!--作者其它作品-->
        <div v-show="haveAuthorOtherBook">
            <div style="padding: 10px 10px 0;">
                <span style="float: left;font-weight: bold">作者其它作品</span>
            </div>
            <div @click="getBookDetail(authorOtherBook.id)" class="author-other-book-container">
                <img :src="authorOtherBook.pic1">
                <ul>
                    <li><span>{{authorOtherBook.title}}</span></li>
                    <li><span>狀態：{{authorOtherBook.zt}}</span></li>
                    <li><span>類型：{{authorOtherBook.type}}</span></li>
                    <li><span>字數：{{authorOtherBook.wordCount}}</span></li>
                </ul>
            </div>
        </div>

        <!--分割線-->
        <div style="width: 100%;height: 10px;background-color: lightgray"></div>

        <!--書友還讀過-->
        <div class="read-other-container">
            <div style="padding: 10px 10px 0;">
                <span style="float: left;font-weight: bold">書友還讀過</span>
            </div>
            <div style="display: flex;flex-wrap: wrap">
                <div class="book-display-container" v-for="book in otherReadList" style="width: 25%">
                    <div @click="getBookDetail(book.id)">
                        <img :src="book.pic1" alt="" />
                        <span style="color: #333333">{{book.title}}</span>
                        <span>作者:{{book.author}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!--客戶端下載-->
        <div @click="jumpDownloadView" class="client-download-container">
            <a>點擊下載立異app</a>
        </div>

        <!--加入書架  開始閱讀-->
        <div class="button-container">
            <button @click="addBookShelf()" style="background-color: white">{{bookShelfButtonText}}</button>
            <button @click="startRead()">開始閱讀</button>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "BookDetailVue",
    data() {
        return {
            bookId: "",
            bookName: "",
            bookDetail: [],
            otherReadList: [],
            authorOtherBook: [],
            haveAuthorOtherBook: false,
            comments: [],
            isBookShelf: false,
            bookShelfButtonText: "加入書架",
            isRequest: false,
            currentReadChapterId: "",
            fromVueName: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            if (typeof this.fromVueName === "undefined") {
                this.$router.push({
                    path: "SelectedVue",
                });
            } else {
                this.$router.push({
                    path: this.fromVueName,
                });
            }
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            window.scrollTo(0, -1);
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getBookIndex");
            params.append("bookId", bookId);
            params.append("uid", this.userId);
            this.isRequest = true;
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.setBookData(res);
                } else {
                    alert(res.data.message);
                }
            });
        },

        //設置書籍信息
        setBookData: function (res) {
            this.bookDetail = res.data.data;
            this.bookName = this.bookDetail.title;
            this.isBookShelf = this.bookDetail.inBookShelf;
            if (this.isBookShelf) {
                this.bookShelfButtonText = "移除書架";
            } else {
                this.bookShelfButtonText = "加入書架";
            }

            if (typeof this.bookDetail.authorOther !== "undefined") {
                this.haveAuthorOtherBook = true;
                this.authorOtherBook = this.bookDetail.authorOther;
            } else {
                this.haveAuthorOtherBook = false;
            }

            if (typeof this.bookDetail.comments !== "undefined") {
                this.comments = this.bookDetail.comments;
            }

            this.getReadOther(this.bookDetail.fl1);
        },

        //獲取書友還讀過的數據
        getReadOther: function (type) {
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("fl1", type);
            params.append("ac", "readerOthers");
            this.$http.post(axios.baseURL, params).then((res) => {
                if (res.data.status) {
                    this.otherReadList = res.data.data;
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //加入書架
        addBookShelf: function () {
            if (this.userId !== null && this.userId !== "null") {
                const params = new URLSearchParams();
                params.append("language", "zh-Hant");
                params.append("dev", "h5");
                params.append("uuid", "123456");
                params.append("ver", "1.0");
                params.append("uid", this.userId);
                if (this.isBookShelf) {
                    //移除書架
                    params.append("ac", "deleteBookMore");
                    params.append("bookIds", this.bookId);
                } else {
                    //加入書架
                    params.append("ac", "addBookShelf");
                    params.append("bookId", this.bookId);
                }
                this.$http.post(axios.baseURL, params).then((res) => {
                    if (res.data.status) {
                        if (this.isBookShelf) {
                            this.bookShelfButtonText = "加入書架";
                        } else {
                            this.bookShelfButtonText = "移除書架";
                        }
                        this.isBookShelf = !this.isBookShelf;
                    }
                    alert(res.data.msg);
                });
            } else {
                this.$router.push({
                    path: "LoginVue",
                });
            }
        },

        //最新章節點擊
        categoryClick: function () {
            this.$router.push({
                path: "CatalogVue",
                query: {
                    bookId: this.bookId,
                    bookName: this.bookName,
                },
            });
        },

        //開始閱讀
        startRead: function () {
            //如果本地該書章節id存在，則直接從已經閱讀到的部分開始讀
            const chapterId = localStorage.getItem(this.bookId);
            if (chapterId !== null) {
                this.$router.push({
                    path: "ChapterDetailVue",
                    query: {
                        bookId: this.bookId,
                        chapterId: chapterId,
                    },
                });
            } else {
                this.$router.push({
                    path: "ChapterDetailVue",
                    query: {
                        bookId: this.bookId,
                        chapterId: this.bookDetail.first_chapterId,
                    },
                });
            }
        },

        //跳轉到下載界面
        jumpDownloadView: function () {
          this.$router.push({
            path: "DownloadVue",
            query: {
              bookId: this.bookId,
              bookName: this.bookName,
              chapterId: this.bookDetail.first_chapterId
            },
          });
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.bookId = this.$route.query.bookId;
        this.fromVueName = this.$route.query.vueName;
        this.getBookDetail(this.bookId);
    },
};
</script>

<style scoped>
.title-style {
    font-weight: bold;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    margin-left: 25%;
}

.book-detail-container {
    max-width: 480px;
    min-height: calc(100vh);
    margin: 0 auto 50px;
    border: 1px solid lightgoldenrodyellow;
    background-color: white;
}

.book-intro-container {
    width: 96%;
    margin-left: 2%;
    margin-top: 60px;
    text-align: left;
    display: flex;
    flex-direction: row;
}

.book-intro-container img {
    width: 30%;
    height: 10%;
}

.book-intro-container ul {
    padding-inline-start: 10px;
    margin-block-start: 0;
    margin-block-end: 0;
}

.book-intro-container ul li {
    list-style: none;
}

.book-intro-container ul li span {
    line-height: 30px;
    font-size: 16px;
    color: #333333;
}

.comment-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
}

.comment-container ul {
    text-align: left;
    padding-inline-start: 10px;
    padding-inline-end: 10px;
}

.comment-container ul li {
    list-style: none;
}

.comment-container ul li span {
    color: #999999;
}

.author-other-book-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    cursor: pointer;
}

.author-other-book-container img {
    width: 25%;
    max-height: 120px;
    padding: 10px;
}

.author-other-book-container ul {
    padding-inline-start: 0;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    float: left;
    text-align: left;
}

.author-other-book-container ul li {
    list-style: none;
}

.author-other-book-container ul li span {
    font-size: 16px;
    line-height: 25px;
}

.read-other-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
}

.button-container {
    position: fixed;
    max-width: 480px;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: lightgrey;
}

.button-container button {
    background-color: #f2c510;
    cursor: pointer;
    border: none;
    font-size: 16px;
    color: black;
    width: 50%;
    height: 45px;
    font-family: 楷體;
}

.button-container button:active {
    background-color: gray;
}

.client-download-container {
    text-align: center;
    margin: 10px 10%;
    display: flex;
    flex-direction: column;
}

.client-download-container a {
    margin-top: 10px;
    height: 30px;
    background-color: firebrick;
    border: none;
    font-size: 16px;
    border-radius: 5px;
    color: white;
    line-height: 30px;
}

.client-download-container a:active {
    background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/BookDetailVue.vue